RivalIQ.module('behaviors', function (behaviors, Admin, Backbone, Marionette, $, _) {

    'use strict';

    behaviors.ImageExpander = Marionette.Behavior.extend({
        previewHeight: 163,
        ui: {
            link: '.img-expander',
            image: '.img-expander img'
        },

        events: {
            'click @ui.link': 'onExpandClick'
        },

        onRender: function () {
            const me = this;

            // Build a disconnected image to retrieve natural height
            // information
            const image = new Image();

            // Do not stop export if the image doesn't load
            const loadingTimeout = setTimeout(function () {
                me.view.triggerMethod('image:rendered');
            }, 5000);

            me.onImageLoad = new $.Deferred();
            image.onload = function () {
                clearTimeout(loadingTimeout);
                me.onImageLoad.resolve(image);
            };

            if (me.ui.image.length) {
                image.src = me.ui.image.attr('src');
            } else { // If we don't have an image, trigger immediately
                me.view.triggerMethod('image:rendered');
            }
        },

        onAttach: function () {

            const me = this;

            const canManipulateDom = function () {

                const width = _.get(me, 'ui.link.width');
                return (!me.isDestroyed && _.isFunction(width));
            };

            me.onImageLoad.done(function (shadowImage) {

                // NOTE in the time between the image loading and now the host
                // view has been destroyed, and it is no longer possible to take
                // action, so we should exit now without doing work
                if (!canManipulateDom()) {

                    return;
                }

                // Predict the height of the image by getting the resize ratio
                let adjustedImageHeight;
                if (shadowImage.width < me.ui.link.width()) {
                    adjustedImageHeight = shadowImage.width;
                } else {
                    adjustedImageHeight = (me.ui.link.width() / shadowImage.width) * shadowImage.height;
                }

                // Adjust image position to vertically center in the space
                const heightDiff = adjustedImageHeight - me.getOption('previewHeight');
                me.offset = (heightDiff > 0 ? -1 * heightDiff / 2 : 0);
                me.ui.image.css('margin-top', me.offset);

                me.ui.image.css('display', 'inline-block');

                // Avoid animating and bouncing images
                _.defer(function () {

                    // NOTE in the time between completing the image load and
                    // now it is possible that the view has been destroyed, so
                    // only if it has not been should we animate the element (it
                    // won't exist otherwise, and an exception will occur)
                    if (canManipulateDom()) {

                        me.ui.link.addClass('animate');
                    }
                });

                me.view.triggerMethod('image:rendered');
            });
        },

        onExpandClick: function () {
            const me = this;

            me.ui.link.toggleClass('in');
            const marginTop = (me.ui.link.hasClass('in') ? 0 : me.offset);

            me.ui.image.css('margin-top', marginTop);
        }
    });
});
